export default "__VITE_ASSET__DCQY9bJN__"